import $ from 'jquery';
import React, { Component } from 'react';
import styles from './style.css';
import {Dummy} from '../';



export default class Economentry extends Dummy {
    onClick() {
        $('#expectations').toggle(500);
    }

    render() {
        return (
            <div className={styles.econom}>
                 <h3>Экономические показатели:</h3>
                <div className="row">
                    <div className="col-md-8">
                        <table className={styles.tg}>
                            <tbody>
                                <tr>
                                    <th className={styles.tgF6ar}>Дата внедрения</th>
                                    <th className={styles.tgCxkv}>{this.getPsValue('ti_6_126_104').value}.{this.getPsValue('ti_6_126_105').value}.{this.getPsValue('ti_6_126_106').value}</th>
                                </tr>
                                <tr>
                                    <th className={styles.tgF6ar}>Дней текущего сезона</th>
                                    {this.getPsValue('ti_6_126_124', 'th', styles.disabled, styles.tgT3d6)}
                                </tr>
                                <tr>
                                    <th className={styles.tgF6ar}>Затраты суммарные</th>
                                    {this.getPsValue('ti_6_126_123', 'th', styles.disabled, styles.tgT3d6)}
                                </tr>
                            </tbody>
                        </table>
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.tgF6ar}></th>
                                <th className={styles.tgF6ar}>Потребленная Э/Э (кВт*ч)</th>
                                <th className={styles.tgF6ar}>Выработанная Т/Э (кВт*ч)</th>
                            </tr>
                            <tr>
                                <td className={styles.tgF6ar}>Сутки предыдущие</td>
                                {this.getPsValue('ti_6_126_11', 'td', styles.disabled, styles.tgT3d6)}
                                {this.getPsValue('ti_6_126_12', 'td', styles.disabled, styles.tgT3d6)}
                            </tr>
                            <tr>
                                <td className={styles.tgF6ar}>Среднесуточные за сезон</td>
                                {this.getPsValue('ti_6_126_14', 'td', styles.disabled, styles.tgT3d6)}
                                {this.getPsValue('ti_6_126_15', 'td', styles.disabled, styles.tgT3d6)}
                            </tr>
                            <tr>
                                <td className={styles.tgF6ar}>Сезон текущий</td>
                                {this.getPsValue('ti_6_126_41', 'td', styles.disabled, styles.tgT3d6)}
                                {this.getPsValue('ti_6_126_42', 'td', styles.disabled, styles.tgT3d6)}
                            </tr>
                            <tr>
                                <td className={styles.tgF6ar}>Сезон предыдущий</td>
                                {this.getPsValue('ti_6_126_48', 'td', styles.disabled, styles.tgT3d6)}
                                {this.getPsValue('ti_6_126_49', 'td', styles.disabled, styles.tgT3d6)}
                            </tr>
                            <tr>
                                <td className={styles.tgF6ar}>Весь период эксплуатации</td>
                                {this.getPsValue('ti_6_126_34', 'td', styles.disabled, styles.tgT3d6)}
                                {this.getPsValue('ti_6_126_35', 'td', styles.disabled, styles.tgT3d6)}
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    </div> 
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/entries/Economentry/index.js